import moment from "moment/moment";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";

export const dataListDate = () => {
    return [
        {
            title: "Hôm nay",
            startDate: moment(),
            endDate: moment(),
            key: KeyConstant.TODAY
        },
        {
            title: "Hôm qua",
            startDate: moment().subtract(1, "days"),
            endDate: moment().subtract(1, "days"),
            key: KeyConstant.YESTERDAY
        }
    ]
}
